export default "__VITE_ASSET__B$NnW256__"